import Request from '@/api/request';

/**
 * @description: user login api
 */

export const getFolders = async (params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    sort: {
      'ranking' : -1,
      // 'id'      : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  console.log(requestParams);
  return await Request.get('/v1/folders', requestParams).then((res) => {
    return res;
  });
};

export const getFolderFiles = async (id, params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/folders/'+id+'/files', requestParams).then((res) => {
    return res;
  });
}

export const getFolder = async (id) => {
  let params = {};
  return await Request.get('/v1/folders/' + id, params).then((res) => {
    return res;
  });
};


export const postFolder = async (params) => {
  return await Request.formpost('/v1/folders', params).then((res) => {
    return res;
  });
}

export const putFolder = async (id, params) => {
  return await Request.put('/v1/folders/'+id, params).then((res) => {
      return res;
  });
}

export const postFolderFile = async (file, params) => {
  return await Request.fileformpost('/v1/folders', 'file', file, params).then((res) => {
    return res;
  });
}

export const postFolderCover = async (folderid, filecover) => {
  let uri = '/v1/folders/'+folderid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putFolderOffline = async (id) => {
  return await Request.put('/v1/folders/'+id + '/offline', {}).then((res) => {
      return res;
  });
}

export const putFolderOnline = async (id) => {
  return await Request.put('/v1/folders/'+id + '/online', {}).then((res) => {
      return res;
  });
}


export const getEventFolders = async (eventid, params) => {
  return await Request.get('/v1/events/'+eventid+'/folders', params).then((res) => {
    return res;
  });
};

export const postEventFolder = async (eventid, folderid, params) => {
  return await Request.formpost('/v1/events/'+eventid+'/folders/from/'+folderid, params).then((res) => {
      return res;
  });
};

export const putEventFolder = async (eventid, id, params) => {
  return await Request.put('/v1/events/'+eventid+'/folders/'+id, params).then((res) => {
      return res;
  });
}

export const postEventFolderCover = async (eventid, filecover, params) => {
  const folderid = params.folderid;
  let uri = '/v1/events/'+eventid+'/folders/'+folderid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putFolderMarkdown = async (folderid, params) => {
  params.type = 0;
  return await Request.put('/v1/folders/'+folderid+'/richtext', params).then((res) => {
    return res;
  });  
};

export const getFolderMarkdown = async (folderid) => {
  return await Request.get('/v1/folders/'+folderid+'/richtext',{type:0}).then((res) => {
    return res;
  });  
};